import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";
import {
  EVENEMENT_OUVERTURE,
  appliquerConsentementExistant,
  chargerMesureAudience,
  enregistrerConsentement,
  supprimerCookiesMesure,
} from "../utils/consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Aucun traceur n'a été chargé par index.html : on applique le choix déjà fait,
    // et on affiche le bandeau si l'utilisateur ne s'est pas encore prononcé.
    const choix = appliquerConsentementExistant();
    if (!choix) setVisible(true);

    const ouvrir = () => setVisible(true);
    window.addEventListener(EVENEMENT_OUVERTURE, ouvrir);
    return () => window.removeEventListener(EVENEMENT_OUVERTURE, ouvrir);
  }, []);

  const accepter = () => {
    enregistrerConsentement("accepte");
    chargerMesureAudience();
    setVisible(false);
  };

  const refuser = () => {
    enregistrerConsentement("refuse");
    supprimerCookiesMesure();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-labelledby="titre-cookies"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-orange-300 shadow-2xl"
    >
      <div className="container mx-auto px-4 py-4 sm:py-6">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-6">
          <div className="flex items-start space-x-3 flex-1">
            <Cookie className="h-6 w-6 text-orange-700 flex-shrink-0 mt-1" aria-hidden="true" />
            <div>
              <h2 id="titre-cookies" className="font-semibold text-gray-900 mb-1">
                Votre choix concernant les cookies
              </h2>
              {/* Version courte sur mobile pour ne pas masquer la page */}
              <p className="text-sm text-gray-700 leading-relaxed">
                <span className="sm:hidden">
                  Cookies de mesure d'audience, déposés uniquement si vous les acceptez.{" "}
                </span>
                <span className="hidden sm:inline">
                  Nous utilisons des cookies de mesure d'audience (Google Analytics et PostHog)
                  pour comprendre comment notre site est consulté. Ils ne sont déposés que si
                  vous les acceptez, et vous pouvez changer d'avis à tout moment. Les cookies
                  nécessaires au fonctionnement du site ne requièrent pas votre accord.{" "}
                </span>
                <Link
                  to="/politique-confidentialite"
                  className="text-orange-700 underline hover:text-orange-800"
                >
                  En savoir plus
                </Link>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:flex sm:flex-row gap-3 lg:flex-shrink-0">
            <Button
              variant="outline"
              onClick={refuser}
              className="border-2 border-gray-300 hover:bg-gray-50 w-full sm:w-auto"
            >
              Tout refuser
            </Button>
            <Button
              onClick={accepter}
              className="bg-orange-700 hover:bg-orange-800 text-white w-full sm:w-auto"
            >
              Tout accepter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
